import dayjs from 'dayjs'

import { toLocaleString2 } from '../strings'

export const parseFollowupAlertData = (data: any[]): any[] => {
  const res = []

  for (const item of data) {
    res.push({
      'general-id': item.id,
      'general-name-total': 0,
      'general-centro': item.lojaId,
      'general-codigo-fornecedor': item.codigoFornecedorProduto,
      'general-codigo-do-produto': item.produtoId,
      'general-nome-do-produto': item.produtoDescricao,
      'general-data-estimada': item.dataPrevistaEntrega,
      'general-data-revisada': item.dataRevisada
        ? dayjs(item.dataRevisada).format('DD/MM/YYYY')
        : '',
      'general-a-fornecer': toLocaleString2(item.quantidadeAbastecimento),
      'general-a-fornecer-raw': item.quantidadeAbastecimento,
      'general-a-fornecer-revisado':
        item.aFornecerRevisado != null
          ? toLocaleString2(item.aFornecerRevisado)
          : '',
      'general-a-fornecer-revisado-raw': item.aFornecerRevisado ?? null,
      'general-data-revisada-raw': item.dataRevisada ?? null,
      'general-a-fornecer-rs': item.dolaresParaForneceder,
      'general-total-pedido': item.valorPedido,
      'general-status-entrega': item.statusPedido,
      'general-status': item.status,
      'general-ruptura-zero': item.rupturaZeroDias ? 'Sim' : 'Não',
      'general-ruptura-ten': item.rupturaDezDias ? 'Sim' : 'Não',
      'general-acao': item.comentario
        ? item.comentario +
          ';' +
          item.dataCriacaoAcompanhamento +
          ';' +
          item.dataSolucaoAcompanhamento
        : '',
      'general-histórico': item.comentario ? 'historico' : '',
      'general-data-faturamento-pedido': item.dataFaturamentoPedido
        ? dayjs(item.dataFaturamentoPedido).format('DD/MM/YYYY')
        : '',
      'general-pedido': item.documentoId,
      'general-data-criacao': item.dataCriacao,
      'general-fornecedor-descricao': item.fornecedorDescricao,
      'general-supplier-id': item.fornecedorId
    })
  }

  return res
}
